import validator from "validator";

//make a place to locally store and get the user language
//when needed during validation process
validator.kta20LanguageAndCountryCode=null;

/**
 * @param languageAndCountryCode
 */
validator.setLanguageAndCountryCode=(languageAndCountryCode: string='en-US')=>{
    validator.kta20LanguageAndCountryCode = languageAndCountryCode;
};

validator.getLanguageAndCountryCode=():string=>{
    return validator.kta20LanguageAndCountryCode;
};

export {validator}

